import { useEffect, useState } from "react";
import "./FormData.css";
import { BannerSkeleton } from "../../BannerSkeleton";
import { isNavigable } from "../../../../Utils/StayUpToDate/RenderComponent";

const FormData = (props: any) => {
  const [loading, setLoading] = useState(true);

  const {
    component,
    brand_color,
    filloutId,
    designTokens,
  } = props;

  useEffect(() => {
    // Create and append the script element when the component mounts
    const script = document.createElement("script");
    script.src = "https://server.fillout.com/embed/v1/";
    script.async = true;
    document.body.appendChild(script);
    setLoading(false);
    // Clean up by removing the script element when the component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      {loading ? (
        <BannerSkeleton designTokens={designTokens} />
      ) : (
        <>
          <div className="mainDiv">
            <p
              className="component-name"
              style={{
                cursor: isNavigable({
                  display_name: component.name,
                  type: component.type,
                })
                  ? "pointer"
                  : "default",
                height: "auto",
                fontFamily: designTokens?.primaryFontFamily,
              }}
            >
              {component.display_name === "Form" && component.name === "Form"
                ? ""
                : component.name}
            </p>
          </div>

          <div
            className="form-data-subcomponent"
            style={{
              marginTop: "0px",
              backgroundColor: brand_color,
              width: "100%",
              fontFamily: designTokens?.secondaryFontFamily,
              // Let Fillout dynamic-resize grow the embed; fixed heights caused
              // mobile inner-scroll and a large empty brand-color gap on desktop.
              overflow: "visible",
              height: "auto",
            }}
          >
            <div
              style={{
                width: "100%",
                minHeight: "400px",
              }}
              data-fillout-id={filloutId}
              data-fillout-embed-type="standard"
              data-fillout-inherit-parameters
              data-fillout-dynamic-resize
            ></div>
          </div>
        </>
      )}
    </>
  );
};

export default FormData;
